import axios from 'axios'

// Configure axios defaults
const API_BASE_URL = import.meta.env.VITE_API_URL || (
  import.meta.env.PROD 
    ? '/api'  // Use relative path in production (routed by CloudFront)
    : 'http://localhost:3000'  // Direct backend in development
)

// Track if we're processing auth to prevent redirect loops
let authProcessingUntil = 0

export function setAuthProcessing(durationMs: number = 5000) {
  authProcessingUntil = Date.now() + durationMs
}

export function isAuthProcessing() {
  return Date.now() < authProcessingUntil
}

// Create axios instance with default config
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Always send cookies
  headers: {
    'Content-Type': 'application/json',
  },
})

// Add request interceptor for debugging
axiosInstance.interceptors.request.use(
  (config) => {
    console.log('API Request:', config.method?.toUpperCase(), config.url)
    return config
  },
  (error) => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// Add response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect if we're processing auth, on auth endpoints, or on public endpoints
      const isPublicEndpoint = error.config.url?.includes('/problem_list') || error.config.url?.includes('/problems/')
      
      if (!isAuthProcessing() && !error.config.url?.includes('/auth/') && !isPublicEndpoint) {
        console.log('Unauthorized - redirecting to login')
        const currentPath = window.location.pathname + window.location.search
        window.location.href = `${API_BASE_URL}/auth/login?return_to=${encodeURIComponent(currentPath)}`
      } else if (isAuthProcessing()) {
        console.log('401 during auth processing - not redirecting')
      } else if (isPublicEndpoint) {
        console.log('401 on public endpoint - allowing non-authenticated access')
      }
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
